import Entity from './entity';
export default class Agency extends Entity<string> {
  name: string;
  contact: string;
  country: string;
  city: string;
  district: string;
  web: string;
  email: string;
  phone: string;
  fax: string;
  address: string;
  taxOffice: string;
  taxNo: string;
  allowUserCount: number;
  logoUrl: string;
  invoiceAttachment: string;
  parentId: string;
  tenantId: number;
  creditLimit: number;
  defaultCurrency: string;
  mikroTransferId: number;
  isProvider: boolean;
  agencyId: string;
  currencyId: string;
}
